import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallLineSeparator } from '../../../../components/separator/LineSeparator';
import styles from './autocomplete_tips.module.scss';

export const AutocompleteTips: FC = () => (
  <div className={styles.tips}>
    <SmallLineSeparator />
    <div className="search-bar-dropdown__cell ">
      <span className={styles.text}>
        <FormattedMessage
          id="search/components/search-bar/dropdown/AutocompleteTips.tsx/1"
          values={{
            bold: (msg: string) => <span className={styles.em}>{msg}</span>,
          }}
        />
      </span>
      <span className={styles.next}>
        <span className={styles.text}>
          <FormattedMessage
            id="search/components/search-bar/dropdown/AutocompleteTips.tsx/2"
            values={{
              bold: (msg: string) => <span className={styles.em}>{msg}</span>,
            }}
          />
        </span>
      </span>
    </div>
  </div>
);
